export { Pause as default } from './Pause';
